
import React from 'react';
import { motion, AnimatePresence } from "framer-motion";
import { NavLink } from "./NavLink";
import { LogIn, LucideIcon } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

interface MobileMenuProps {
  isOpen: boolean;
  navItems: Array<{
    label: string;
    href: string;
    icon: LucideIcon;
    badge?: number | null;
  }>;
  setIsOpen: (value: boolean) => void;
}

const MobileMenu = ({ isOpen, navItems, setIsOpen }: MobileMenuProps) => {
  const { t } = useLanguage();
  
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div 
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.3 }}
          className="bg-background border-t border-border overflow-hidden z-40"
        >
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            {navItems.map((item) => (
              <NavLink
                key={item.href}
                to={item.href}
                className="block px-3 py-2 rounded-md text-base font-medium flex items-center"
                icon={item.icon}
                badge={item.badge}
                onClick={() => setIsOpen(false)}
              >
                {item.label}
              </NavLink>
            ))}
            <NavLink
              to="/auth"
              className="block px-3 py-2 rounded-md text-base font-medium text-muted-foreground hover:bg-secondary hover:text-foreground flex items-center"
              icon={LogIn}
              onClick={() => setIsOpen(false)}
            >
              {t('login')}
            </NavLink>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MobileMenu;
